module.exports = __webpack_public_path__ + "static/media/Piercing-ear-design.ea10b4b2.png";